import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client  } from '../client';

export async function getProduct(slug:string): Promise<[]> {
  return new AxiosRequestSender(client)
    .setUrl('product')
    .setMethod('POST')
    .setProps([{slug: slug}])
    .send();
}
